export const INDEX_TOP_LEVEL = 100000;

export const BREAKPOINTS = {
  sm: "480px",
  md: "768px",
} as const;
